import { render } from "./ProfileEdit.vue?vue&type=template&id=6bc1996d"
import script from "./ProfileEdit.vue?vue&type=script&lang=js"
export * from "./ProfileEdit.vue?vue&type=script&lang=js"
script.render = render

export default script